import React, { Component, useState, useMemo, useEffect } from 'react';

import { fetchData } from "../common/networkRequests";

import './ModalStyle.css';
import { FaArrowDown, FaRegWindowRestore } from "react-icons/fa";

import { getObjectsValue, clearDisplayData, forceClearData, calculateInterest, padding, RelevantIcon } from '../oro-module/commonFunctions';
import { ResponsiveBar } from '@nivo/bar'
import moment from "moment";

let colors = ["hsl(85, 70%, 50%)", "hsl(250, 70%, 50%)", "hsl(119, 70%, 50%)", "hsl(353, 70%, 50%)", "hsl(62, 70%, 50%)", "hsl(311, 70%, 50%)", "pink", "green"];

let BAR_MAX_WIDTH = 100;

const CustomBarComponent = ({ bar: { x, y, width, height, color } }) => {
  console.log({ x, y, width, height, color })
  const w = width > BAR_MAX_WIDTH ? BAR_MAX_WIDTH : width;

  return (
    <rect
      x={x + width / 2 - w / 2}
      y={y}
      width={w}
      height={height}
      rx={Math.min(w, height) / 2}
      fill={color} />
  );
};


let defaultData = [
  {
    "branch": "Branch 1",
    "cash": 5,
    "cashColor": "hsl(85, 70%, 50%)",
    "recon": 3,
    "reconColor": "hsl(250, 70%, 50%)",
    "cheques": 2,
    "chequesColor": "hsl(119, 70%, 50%)",
    "manual": 7,
    "manualColor": "hsl(353, 70%, 50%)",
    "general": 5,
    "generalColor": "hsl(62, 70%, 50%)",
    "loans": 4,
    "loansColor": "hsl(311, 70%, 50%)"
  },
  {
    "branch": "Branch 2",
    "cash": 4,
    "cashColor": "hsl(349, 70%, 50%)",
    "recon": 10,
    "reconColor": "hsl(273, 70%, 50%)",
    "cheques": 3,
    "chequesColor": "hsl(115, 70%, 50%)",
    "manual": 3,
    "manualColor": "hsl(240, 70%, 50%)",
    "general": 1,
    "generalColor": "hsl(133, 70%, 50%)",
    "loans": 9,
    "loansColor": "hsl(304, 70%, 50%)"
  },
  {
    "branch": "Branch 3",
    "cash": 2,
    "cashColor": "hsl(160, 70%, 50%)",
    "recon": 1,
    "reconColor": "hsl(284, 70%, 50%)",
    "cheques": 6,
    "chequesColor": "hsl(10, 70%, 50%)",
    "manual": 9,
    "manualColor": "hsl(165, 70%, 50%)",
    "general": 3,
    "generalColor": "hsl(348, 70%, 50%)",
    "loans": 5,
    "loansColor": "hsl(333, 70%, 50%)"
  },
  {
    "branch": "Branch 4",
    "cash": 6,
    "cashColor": "hsl(176, 70%, 50%)",
    "recon": 9,
    "reconColor": "hsl(199, 70%, 50%)",
    "cheques": 9,
    "chequesColor": "hsl(212, 70%, 50%)",
    "manual": 5,
    "manualColor": "hsl(86, 70%, 50%)",
    "general": 8,
    "generalColor": "hsl(152, 70%, 50%)",
    "loans": 5,
    "loansColor": "hsl(8, 70%, 50%)"
  },
  {
    "branch": "Branch 5",
    "cash": 6,
    "cashColor": "hsl(55, 70%, 50%)",
    "recon": 8,
    "reconColor": "hsl(153, 70%, 50%)",
    "cheques": 3,
    "chequesColor": "hsl(225, 70%, 50%)",
    "manual": 7,
    "manualColor": "hsl(166, 70%, 50%)",
    "general": 7,
    "generalColor": "hsl(121, 70%, 50%)",
    "loans": 9,
    "loansColor": "hsl(304, 70%, 50%)"
  },
  {
    "branch": "Branch 6",
    "cash": 4,
    "cashColor": "hsl(117, 70%, 50%)",
    "recon": 9,
    "reconColor": "hsl(63, 70%, 50%)",
    "cheques": 6,
    "chequesColor": "hsl(220, 70%, 50%)",
    "manual": 2,
    "manualColor": "hsl(124, 70%, 50%)",
    "general": 3,
    "generalColor": "hsl(38, 70%, 50%)",
    "loans": 6,
    "loansColor": "hsl(58, 70%, 50%)"
  },
  {
    "branch": "Branch 7",
    "cash": 3,
    "cashColor": "hsl(326, 70%, 50%)",
    "recon": 9,
    "reconColor": "hsl(315, 70%, 50%)",
    "cheques": 3,
    "chequesColor": "hsl(99, 70%, 50%)",
    "manual": 1,
    "manualColor": "hsl(326, 70%, 50%)",
    "general": 3,
    "generalColor": "hsl(128, 70%, 50%)",
    "loans": 2,
    "loansColor": "hsl(336, 70%, 50%)"
  }
];


const NivoChart = (props) => {

  let [allData, setAllData] = useState([]);
  let [loading, setloading] = useState(false);
  let [columns, setColumns] = useState([]);
  let [indexBy, setIndexBy] = useState("");
  let [xLegend, setxLegend] = useState("");
  let [yLegend, setyLegend] = useState("");





  let { values, showvalues, ddType, dformat, clickable, emptymsg, width } = props.component;



  const setChartData = (response) => {
    setIndexBy("branch");
    let newChecklist = [];
    let cols = [];
    response.results.map((res, idx) => {
      let row = {};
      row['branch'] = res.branch_display.replace('Sector', 'Sec.');
      for (var i = 0; i < Object.keys(res).length; i++) {
        let key = Object.keys(res)[i];
        if (key != 'branch_display') {
          row[key] = res[key];
          row[key + 'Color'] = colors[i - 1];
        }
      }
      newChecklist.push(row);
    });
    setColumns(['cash', 'recon', 'cheques', 'manual', 'general', 'loans', "deposits"]);
    setAllData(newChecklist);
    setloading(false);
    console.log({ newChecklist })

    setxLegend("Branches")
    setyLegend("Non Compliance")

  }



  // { "results": [{ "inspection_type": "Cash Verification", "label_uid": "d791b728-7b76-4421-b8b7-313510347952", "uid": "0b52b547-2f03-47be-b611-f629d2f0a7e5", "acknowledge": 0, "fastpath": "inspections", "deadline": "2022-01-19T18:30:00.000Z", "total": 2, "submitted": 2, "success": 1, "incomplete": 0, "not_started": 0, "in_progress": 0, "almost_complete": 0, "complete": 1, "yes": 0, "no": 0 }, { "inspection_type": "Reconcilliation & Balances", "label_uid": "3e897032-18fc-41de-b48e-512e2ecee13c", "uid": "952b8112-8571-4fd5-ad68-f6167f888c98", "acknowledge": 1, "fastpath": "inspections", "deadline": "2022-01-19T18:30:00.000Z", "total": 1, "submitted": 1, "success": 1, "incomplete": 0, "not_started": 1, "in_progress": 0, "almost_complete": 0, "complete": 0, "yes": 0, "no": 0 }], "timeTaken": 206 }


  const setChartData18 = (response) => {
    let newChecklist = [];
    let cols = ["no", "not_started", "incomplete", "in_progress", "almost_complete", "complete", "yes"];
    response.results.map((res, idx) => {
      let row = {};
      row['display_name'] = res['display_name'];
      for (var i = 0; i < Object.keys(res).length; i++) {
        let key = Object.keys(res)[i];
        if (cols.indexOf(key) != -1) {
          row[key] = res[key];
          row[key + 'Color'] = colors[i - 1];
        }
      }
      newChecklist.push(row);
    });

    console.log({ newChecklist })

    setIndexBy("display_name");
    setColumns(cols);

    setxLegend("Inspection Group")
    setyLegend("Compliance")

    setAllData(newChecklist);
    setloading(false);
  }


  const setChartDatarpcf13 = (response) => {
    let newChecklist = [];
    let cols = ["total_amount", "returned_amount"];
    response.results.map((res, idx) => {
      let row = {};
      row['display_name'] = res['talathi_name'];
      for (var i = 0; i < Object.keys(res).length; i++) {
        let key = Object.keys(res)[i];
        if (cols.indexOf(key) != -1) {
          row[key] = res[key];
          row[key + 'Color'] = colors[i - 1];
        }
      }
      newChecklist.push(row);
    });

    console.log({ newChecklist })

    setIndexBy("display_name");
    setColumns(cols);

    setxLegend("Talathi")
    setyLegend("Amount")

    setAllData(newChecklist);
    setloading(false);
  }

  const setChartDatarpcf23 = (response) => {
    let newChecklist = [];
    let cols = ["total_amount", "returned_amount"];
    response.results.map((res, idx) => {
      let row = {};
      row['display_name'] = res['taluka_name'];
      for (var i = 0; i < Object.keys(res).length; i++) {
        let key = Object.keys(res)[i];
        if (cols.indexOf(key) != -1) {
          row[key] = res[key];
          row[key + 'Color'] = colors[i - 1];
        }
      }
      newChecklist.push(row);
    });

    console.log({ newChecklist })

    setIndexBy("display_name");
    setColumns(cols);

    setxLegend("Taluka")
    setyLegend("Amount")

    setAllData(newChecklist);
    setloading(false);
  }





  const setChartDatarpcf1 = (response) => {
    let newChecklist = [];
    let cols = ["amount_failed", "amount_success"];
    let colors2 = ["red", "green"];
    response.results.map((res, idx) => {
      let row = {};
      let colno = 0;
      // row['display_name'] = moment(res['createdat']).format("DD/MM/YYYY");
      row['display_name'] = res['createdat'];
      for (var i = 0; i < Object.keys(res).length; i++) {
        let key = Object.keys(res)[i];
        if (cols.indexOf(key) != -1) {
          row[key] = res[key];
          row[key + 'Color'] = colors[colno + 2];
          colno += 1;
        }
      }
      newChecklist.push(row);
    });

    console.log({ newChecklist })

    setIndexBy("display_name");
    setColumns(cols);

    setxLegend("Date")
    setyLegend("Amounts")

    setAllData(newChecklist);
    setloading(false);
  }


  const setChartData16 = (response) => {
    let newChecklist = [];
    let cols = ["notstarted", "incomplete", "inprogress", "almost", "complete"];
    // console.log({ response });
    response.results.map((res, idx) => {
      let row = {};
      row['display_name'] = res.display_name;
      for (var i = 0; i < Object.keys(res).length; i++) {
        let key = Object.keys(res)[i];
        if (cols.indexOf(key) != -1) {
          row[key] = res[key];
          row[key + 'Color'] = colors[i - 1];
        }
      }
      newChecklist.push(row);
    });

    setIndexBy("display_name");
    setColumns(cols);

    setxLegend("Inspection Group")
    setyLegend("Compliance")


    setAllData(newChecklist);
    setloading(false);

  }



  const getChartData = () => {
    let pd = { gui: "dashboard" };
    let saveThis = { dataType: "search", pageData: pd, currentPage: ddType };
    setloading(true);
    if (ddType == 'rpad35') {
      fetchData({ url: 'cbsurl', postData: saveThis, current: { props }, cbf: setChartData });
    }
    else if (ddType == 'rpad16' || ddType == 'rpad8') {
      let { selectedTourBranch } = props.parentState.LocalVars;
      saveThis['pageData']['branch_uid'] = selectedTourBranch.value;
      fetchData({ url: 'cbsurl', postData: saveThis, current: { props }, cbf: setChartData16 });
    }
    else if (ddType == 'rpad18') {
      let { selectedTourBranch } = props.parentState.LocalVars;
      saveThis['pageData']['branch_uid'] = selectedTourBranch.value;
      fetchData({ url: 'cbsurl', postData: saveThis, current: { props }, cbf: setChartData18 });
    }
    else if (ddType == 'rpcf1') {
      let { selectedTourBranch } = props.parentState.LocalVars;
      saveThis['pageData']['branch_uid'] = selectedTourBranch.value;
      fetchData({ url: 'cbsurl', postData: saveThis, current: { props }, cbf: setChartDatarpcf1 });
    }
    else if (ddType == 'rpcf13') {
      fetchData({ url: 'cbsurl', postData: saveThis, current: { props }, cbf: setChartDatarpcf13 });
    }
    else if (ddType == 'rpcf23') {
      fetchData({ url: 'cbsurl', postData: saveThis, current: { props }, cbf: setChartDatarpcf23 });
    }
    else if (ddType == 'rpad37' || ddType == 'rpad7' || ddType == 'rpad17' || ddType == "rpad19") {
      fetchData({ url: 'cbsurl', postData: saveThis, current: { props }, cbf: setChartData18 });
    }
    else {
      setAllData(defaultData);
      setloading(false);
    }
  }

  let { currentPage } = props.parentState;
  let { selectedTourBranch } = props.parentState.LocalVars;


  let changed = "";
  if (ddType == 'rpad37' || ddType == 'rpad7' || ddType == 'rpad19' || ddType == "rpcf13" || ddType == "rpcf23") {
    changed = []
  }
  else {
    changed = [selectedTourBranch];
  }

  useEffect(() => getChartData(), changed);

  let block = window.screen.width / 14;

  // console.log({ allData, columns, indexBy })

  return (
    <div style={{ height: 300, width: block * width }}>
      {!loading &&
        <ResponsiveBar
          data={allData}
          keys={columns}
          indexBy={indexBy}
          margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
          padding={0.3}
          valueScale={{ type: 'linear' }}
          indexScale={{ type: 'band', round: true }}
          colors={{ scheme: 'nivo' }}
          barComponent={CustomBarComponent}

          defs={[
            {
              id: 'dots',
              type: 'patternDots',
              background: 'inherit',
              color: '#38bcb2',
              size: 4,
              padding: 1,
              stagger: true
            },
            {
              id: 'lines',
              type: 'patternLines',
              background: 'inherit',
              color: '#eed312',
              rotation: -45,
              lineWidth: 6,
              spacing: 10
            }
          ]}
          fill={[
            {
              match: {
                id: 'general'
              },
              id: 'dots'
            },
            {
              match: {
                id: 'cheques'
              },
              id: 'lines'
            }
          ]}
          borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: xLegend,
            legendPosition: 'middle',
            legendOffset: 32
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: yLegend,
            legendPosition: 'middle',
            legendOffset: -40
          }}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
          legends={[
            {
              dataFrom: 'keys',
              anchor: 'bottom-right',
              direction: 'column',
              justify: false,
              translateX: 120,
              translateY: 0,
              itemsSpacing: 2,
              itemWidth: 100,
              itemHeight: 20,
              itemDirection: 'left-to-right',
              itemOpacity: 0.85,
              symbolSize: 20,
              effects: [
                {
                  on: 'hover',
                  style: {
                    itemOpacity: 1
                  }
                }
              ]
            }
          ]}
          role="application"
          ariaLabel="Nivo bar chart demo"
          barAriaLabel={function (e) { return e.id + ": " + e.formattedValue + " in branch: " + e.indexValue }}
        />
      }
      {loading && <div className="loadingChart">loading . . . </div>}
    </div>
  )
}

export default NivoChart; 